import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="text-dark mt-auto">
      <Container>
        <Row className="mb-4">
          <Col md={4} className="mb-4 mb-md-0">
            <h5 className="fw-bold mb-3 text-dark d-flex align-items-center">
              <img
                src="/logo.svg"
                alt="Paperdate Logo"
                height="24"
                className="me-2"
              />
              Paperdate
            </h5>
            <p className="text-muted">
              Connecting hearts and creating meaningful relationships.
              Find your perfect match on Paperdate.
            </p>
            <div className="d-flex gap-3 mt-3 social-icons">
              <a href="#" className="fs-5 transition-transform">
                <i className="bi bi-facebook"></i>
              </a>
              <a href="#" className="fs-5 transition-transform">
                <i className="bi bi-twitter"></i>
              </a>
              <a href="#" className="fs-5 transition-transform">
                <i className="bi bi-instagram"></i>
              </a>
            </div>
          </Col>

          <Col md={2} className="mb-4 mb-md-0">
            <h6 className="fw-bold mb-3 text-dark">Company</h6>
            <ul className="list-unstyled">
              <li className="mb-2">
                <Link to="/about" className="text-decoration-none footer-link">About Us</Link>
              </li>
              <li className="mb-2">
                <Link to="/careers" className="text-decoration-none footer-link">Careers</Link>
              </li>
              <li className="mb-2">
                <Link to="/press" className="text-decoration-none footer-link">Press</Link>
              </li>
              <li className="mb-2">
                <Link to="/blog" className="text-decoration-none footer-link">Blog</Link>
              </li>
            </ul>
          </Col>

          <Col md={2} className="mb-4 mb-md-0">
            <h6 className="fw-bold mb-3 text-dark">Support</h6>
            <ul className="list-unstyled">
              <li className="mb-2">
                <Link to="/help" className="text-decoration-none footer-link">Help Center</Link>
              </li>
              <li className="mb-2">
                <Link to="/safety" className="text-decoration-none footer-link">Safety Tips</Link>
              </li>
              <li className="mb-2">
                <Link to="/community" className="text-decoration-none footer-link">Community Guidelines</Link>
              </li>
              <li className="mb-2">
                <Link to="/contact" className="text-decoration-none footer-link">Contact Us</Link>
              </li>
            </ul>
          </Col>
        </Row>

        <hr className="my-4" style={{ borderColor: '#ccc' }} />

        <Row className="align-items-center">
          <Col md={6} className="text-center text-md-start mb-3 mb-md-0">
            <p className="text-muted mb-0">
              © {currentYear} Paperdate. All rights reserved.
            </p>
          </Col>
          <Col md={6} className="text-center text-md-end">
            <ul className="list-inline mb-0">
              <li className="list-inline-item">
                <Link to="/terms" className="text-decoration-none footer-link">Terms</Link>
              </li>
              <li className="list-inline-item ms-3">
                <Link to="/privacy" className="text-decoration-none footer-link">Privacy</Link>
              </li>
              <li className="list-inline-item ms-3">
                <Link to="/cookies" className="text-decoration-none footer-link">Cookies</Link>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
